import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { TutorialService } from '../core/tutorial.service';
import { MatDialog } from '@angular/material/dialog';
import { TutorialDialogComponent, TutorialItem } from '../shared/tutorial-dialog/tutorial-dialog.component';
import { DashboardService } from '../pages/dashboard/dashboard.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(
    private auth: AuthService,
    private router: Router,
    private tutorial: TutorialService,
    private dialog: MatDialog,
    private dashboard: DashboardService
  ) {}

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  showTutorial() {
    const user = this.auth.getUser() as any;
    const userId = user?.id || user?.userId || null;
    const items: TutorialItem[] = [];
    const perms = (this.auth.getPermissions() || []).map((p: string) => p.toLowerCase());

    items.push({ title: 'Dashboard', description: 'Refresh for live KPIs; see fleet distance, compliance, supply, requests.' });
    if (perms.includes('staff.manage') || perms.includes('staff.request.approve')) {
      items.push({ title: 'Payroll', description: 'Generate slips, set delivery pricing, use manual units or fixed amounts.' });
    }
    if (perms.includes('project.view') || perms.includes('project.task.manage')) {
      items.push({ title: 'Projects', description: 'My Todo shows your tasks; Tasks/Analytics for project progress.' });
    }
    if (perms.includes('manage_logistics')) {
      items.push({ title: 'Logistics', description: 'Record meter/phone logs daily; Maintenance lists distances and logs.' });
    }
    if (perms.includes('manage_supply') || perms.includes('supply.dispatch.manage')) {
      items.push({ title: 'Supply', description: 'Log dispatches; analytics shows gross/commission/net.' });
    }
    if (perms.includes('view_reports')) {
      items.push({ title: 'Reports', description: 'Filter/print delivery and supply reports with watermark.' });
    }

    this.dialog.open(TutorialDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      autoFocus: false,
      restoreFocus: false,
      panelClass: 'tutorial-dialog-panel',
      data: { items, title: 'Quick Tour' }
    }).afterClosed().subscribe((dontShow: boolean) => {
      if (dontShow) this.tutorial.dismiss(userId, 'dashboard');
      else this.tutorial.reset(userId, 'dashboard');
    });
  }
}
